import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dropdown",
    "submitButton",
  ]

  connect() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
    }

    if (this.hasDropdownTarget) {
      this.select2 = $(this.dropdownTarget).select2({
        theme: "bootstrap",
        width: "100%",
        allowClear: true,
        placeholder: "What best describes your business?",
        minimumResultsForSearch: Infinity
      })

      this.select2.on("select2:select select2:clear", this.select2Changed.bind(this))
    }
  }

  select2Changed(e) {
    let disableSubmit = false
    if (e.target.value === "") {
      disableSubmit = true
    }

    this.submitButtonTarget.disabled = disableSubmit
  }
}
